<template>
  <div>
    <headerNavbar title="我的体检队列">
    </headerNavbar>
    <div v-if="state">
      <div class="user-header">
        <div class="user-name-row">
          <div class="user-name">{{state.Customer.Name}}</div>
          <div class="btn-wrap">
            <div class="logout-btn" @click="logout">退出</div>
          </div>
        </div>
        <div class="user-info-row">体检日期：{{state.Customer.CheckDate|dateFormat()}}</div>
        <div class="user-info-row">体检编号：{{state.Customer.ID}}</div>
        <div class="user-info-row">手机号码：{{state.Customer.PhoneNumber|mask("phone")}}</div>
      </div>
      <div class="wrapper">
        <div class="card-body" v-if="currentQueue">
          <div>
            <div class="queue-head">
              <div class="queue-head__station">
                <span>当前诊室</span>
                <h2>{{currentQueue.RoomName}}</h2>
              </div>
              <div class="queue_head__position">
                <span>当前位置</span>
                <h2 class="van-coupon__name">{{currentQueue.Position|queuePosition}}</h2>
              </div>
            </div>
            <div class="division">
              <div class="division-line"></div>
            </div>
            <div class="queue-info">
              <div class="queue-info__row">
                <p class="queue-info__label">诊室位置</p>
                <p class="queue-info__value">{{currentQueue.CurrentRoomState}}</p>
              </div>
              <div class="queue-info__row">
                <p class="queue-info__label">等候时间</p>
                <!-- <p class="queue-info__value">预计 {{currentQueue.ExpectedWaitTime}} 分钟</p> -->
                <p class="queue-info__value"></p>
              </div>
              <div class="queue-info__row">
                <p class="queue-info__label">温馨提示</p>
                <p class="queue-info__value">请依次耐心等候</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div>
            <van-tabs v-model="tabIndex">
              <van-tab title="未完成">
                <div class="item-wrapper" v-if="unCompleteTasks && unCompleteTasks.length>0">
                  <ul>
                    <li v-for="(item,i) in unCompleteTasks" :key="i" class="item__row">
                      <div>
                        {{item.ExamTaskName}}
                        <span class="item-status">
                          <van-icon name="clock-o" size="16" color="#666666" />
                        </span>
                      </div>
                      <div class="complete-time">{{item.remark}}</div>
                    </li>
                  </ul>
                </div>
                <div class="empty-wrapper" v-else>
                  <img src="@/assets/images/icon-success.png" />
                  <p>已完成所有项目，请到前台交回导检单</p>
                </div>
              </van-tab>
              <van-tab title="已完成">
                <div class="item-wrapper">
                  <ul>
                    <li v-for="(item,i) in completedTasks" :key="i" class="item__row">
                      <div>
                        {{item.ExamTaskName}}
                        <span class="item-status">
                          <van-icon name="checked" size="16" color="#07c160" />
                        </span>
                      </div>
                      <div class="item-footer">
                        <div class="complete-time">完成时间：{{item.OutQueueTime|dateFormat('HH:mm:ss')}}</div>
                        <div class="comment-wrap">
                          <!-- <van-button size="mini" type="default" v-show="false" round @click="show = true">评价
                          </van-button> -->
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </div>
      <!-- 弹出窗口内容 -->
      <van-popup v-model="show">
        <div class="popup-wrapper">
          <div class="sawtooth">
            <div>
              <van-icon name="passed" size="32" />
            </div>
            <div class="content-title">取号成功！</div>
            <div class="division">
              <div class="division-line"></div>
            </div>
            <div class="ticket-wrapper">
              <div class="ticket-item">
                <div class="ticket-item-title">排队诊室</div>
                <div class="ticket-item-result">抽血3号</div>
              </div>
              <div class="ticket-item">
                <div class="ticket-item-title">前面等候</div>
                <div class="ticket-item-result">5人</div>
              </div>
              <div class="ticket-item">
                <div class="ticket-item-title">排队号码</div>
                <div class="ticket-item-result">NO.123</div>
              </div>
            </div>
            <div class="content-test" style="width:400px;background-color:white;padding:80px 10px;">
              <h3 class="fs36">现在在做企业微信，企业HR发送体检通知给到员工，员工会接到这么一条图文消息，你看下图文消息中的标题（最多16字）和副标题（最多32字）要怎么描述告知员工这是通知员工体检的邀请。
              </h3>
            </div>
          </div>
          <div class="popup-footer">
            <van-button size="normal" plain type="primary">确定</van-button>
          </div>
        </div>
      </van-popup>
    </div>
    <div v-else>
      <van-empty image="search" :description="errMsg" />
    </div>
  </div>
</template>

<style lang="less" scoped>
  .wrapper {
    margin-top: 160px;
    position: relative;
  }

  .user-header {
    height: 200px;
    padding: 16px 28px;
    background-image: linear-gradient(0deg, #89f7fe 0%, #66a6ff 100%);
    // background-color: #ffb937;
    position: absolute;
    left: 0;
    right: 0;
    top: 46px;
    z-index: 0;
    color: #fff;

    .user-name-row {
      display: flex;

      .user-name {
        font-size: 24px;
        line-height: 40px;
        color: #fff;
        flex: 1
      }

      .btn-wrap {
        .logout-btn {
          margin: 8px;
          border: 1px solid #fff;
          padding: 4px 10px;
          border-radius: 12px;
          line-height: 12px;
          font-size: 13px;
          background-color: #59595930;
        }
      }

    }


    .user-info-row {
      font-size: 14px;
      line-height: 32px;
    }
  }

  .card-body {
    margin: 0 16px 16px 16px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    z-index: 2;
  }

  .queue-head {
    display: flex;
    margin: 12px 16px 0px 16px;

    .queue-head__station {
      flex: 1;
    }

    h2 {
      font-size: 18px;
      font-weight: 400;
      margin: 8px 0px;
    }

    .item-status {
      font-size: 16px;
      color: #888888;
    }

    span {
      color: #bababa;
    }
  }

  .division {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;
    height: 16px;
    z-index: 2;
  }

  .division::before {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    left: -8px;
    top: 0;
    background-color: #eff2f7;
    border-radius: 8px;
    z-index: 3;
  }

  .division::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    right: -8px;
    top: 0;
    background-color: #eff2f7;
    border-radius: 8px;
    z-index: 3;
  }

  .division-line {
    margin: 0 0.4rem;
    width: 100%;
    height: 0;
    border-bottom: 1px dashed #e4e4e4;
    transform: scaleY(0.51);
  }

  .queue-info {
    margin: 16px;
    font-size: 14px;

    .queue-info__row {
      display: flex;
      line-height: 28px;
    }

    .queue-info__label {
      color: #888888;
      width: 80px;
    }

    .queue-info__value {
      flex: 1;
    }
  }

  .block-title {
    margin: 0;
    padding: 24px 16px 16px;
    color: rgba(69, 90, 100);
    font-weight: normal;
    font-size: 18px;
    text-align: center;
  }

  h3 {
    margin: 0;
    font-weight: normal;
    font-size: inherit;
  }

  .popup-wrapper {
    padding: 20px;
    background-color: #eff2f7;
    text-align: center;

    .sawtooth {
      padding: 20px 0px;
      /* 相对定位，方便让before和after伪元素绝对定位偏移 */
      position: relative;
      border-top: 5px solid rgb(235, 235, 235);
      // box-sizing: border-box;
      // box-shadow: 0px -6px 4px 0 rgba(0, 0, 0, 0.05);
      background: #ffffff;

      .content-title {
        font-size: 18px;
        text-align: center;
        line-height: 48px;
      }
    }

    .sawtooth:after {
      content: " ";
      height: 0;
      width: 100%;
      /* 绝对定位进行偏移 */
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .sawtooth:after {
      /* 圆点型的border */
      border-bottom: 10px dotted #eff2f7;
      /* 偏移一个半径，让圆点的一半覆盖p */
      bottom: -5px;
    }

    .discount {
      border-right: 1px dashed #f5f5f5;
      padding: 10px;
      flex: 1;
      box-sizing: border-box;
      background-color: #ffffff;
    }

    .receive {
      text-align: center;
      width: 102px;
      line-height: 90px;
      height: 90px;
      box-sizing: border-box;
      margin-right: 5px;
      background-color: #ffb937;
    }

    .ticket-wrapper {
      margin: 10px 0;
      display: flex;

      .ticket-item {
        flex: 1;

        .ticket-item-title {
          font-size: 14px;
          color: #888888;
          margin-bottom: 10px;
        }

        .ticket-item-result {
          font-size: 18px;
        }
      }
    }

    .popup-footer {
      margin-top: 10px;

      .van-button {
        width: 100%;
      }
    }
  }

  .item-wrapper {
    .item__row {
      padding: 12px;
      border-bottom: 1px solid #f2f2f2;

      .item-status {
        float: right;
      }

      .item-footer {
        display: flex;
        margin-top: 8px;

        .complete-time {
          color: #888888;
          font-size: 13px;
          line-height: 25px;
          flex: 1;
        }

        .comment-wrap {
          .van-button--mini {
            padding: 0 8px;
          }
        }
      }
    }
  }

  .empty-wrapper {
    img {
      height: 80px;
      margin: 32px;
    }

    height: 360px;
    text-align: center;
  }
</style>

<script>
  import Vue from "vue";

  import {
    NavBar
  } from "vant";
  Vue.use(NavBar);

  import {
    Icon
  } from "vant";
  Vue.use(Icon);

  import {
    Tab,
    Tabs,
    Button
  } from "vant";
  Vue.use(Tab)
    .use(Tabs)
    .use(Button);

  import {
    Popup
  } from "vant";
  Vue.use(Popup);

  import {
    Cell,
    CellGroup
  } from "vant";
  Vue.use(Cell).use(CellGroup);

  import {
    Step,
    Steps
  } from "vant";
  Vue.use(Step).use(Steps);

  import headerNavbar from '../components/headerNavbar';
  import {
    getQueueState
  } from "@/api/tjpd.js";

  export default {
    components: {
      headerNavbar
    },
    data() {
      return {
        state: null,
        userProfile: {},
        errMsg: null,
        show: false,
        tabIndex: 0,
        timer: null,
      };
    },
    computed: {
      currentQueue: function () {
        if (!this.state) {
          return null;
        } else {
          return this.state.CurrentQueue;
        }
      },
      completedTasks: function () {
        if (!this.state || !this.state.CustomerTasks) {
          return [];
        } else {
          let arr = this.state.CustomerTasks.filter(i => i.ExamTaskStatus == 2);
          //按完成时间倒序排序
          return arr.sort((a, b) => {
            return a.OutQueueTime > b.OutQueueTime ? -1 : 1;
          })
        }
      },
      unCompleteTasks: function () {
        if (!this.state || !this.state.CustomerTasks) {
          return [];
        } else {
          return this.state.CustomerTasks.filter(i => i.ExamTaskStatus == 0 || i.ExamTaskStatus == 1);
        }
      }
    },
    filters: {
      queuePosition: function (value) {
        if (value > 0) {
          return "第" + value.toString() + "位";
        } else if (value == 0) {
          return "正在检查";
        } else {
          return ""
        }
      }

    },
    mounted() {
      this.getQueueData();
      //刷新
      if (!this.timer) {
        let _this = this;
        this.timer = setInterval(() => {
          _this.getQueueData();
        }, 10000);
      }
    },
    beforeDestroy() {
      this.clearTimer();
    },
    methods: {
      logout() {
        this.clearTimer();
        this.$router.push("/");
      },
      clearTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      // 获取排队记录
      getQueueData() {
        var hospId = this.$route.query.hospid;
        getQueueState(hospId).then(res => {
          if (res.code == 200) {
            let json = res.data;
            this.state = JSON.parse(json);
          } else {
            this.errMsg = res.msg;
          }
        })
      }
    },
  };
</script>